module.exports = __webpack_public_path__ + "img/total-1.6862c9d0.png";